import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';

export const centerPositionVertically = (
  position: RelativeAbsolutePosition,
  height: number,
): RelativeAbsolutePosition => {
  const relativeY = height / 2;
  const diffY = relativeY - position.relative.y;

  return {
    relative: {
      x: position.relative.x,
      y: relativeY,
    },
    absolute: {
      x: position.absolute.x,
      y: position.absolute.y + diffY,
    },
  };
};
